import React from 'react'
import {Col, Form, Button } from 'react-bootstrap';
import axios from 'axios';


const FormContact = ()=>{

      const [formData, setFormdata] = React.useState({
                                                        full_name:'',
                                                        email:'',
                                                        phone:'',
                                                        order_id:'',
                                                        message:'',
                                                    });

      const inputHandler = event => {
        const elm = event.target;
        setFormdata({ 
            ...formData, 
            [elm.name]:elm.value
         });
      }

      const [validated, setValidated] = React.useState(false);
      const handleSubmit = (event) => {
        
        const form = event.currentTarget;
        // invalid. stop
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        // valid. send mail
        else{
          sendmailHandler(event, form);
        }
        
        // marked as validated
        setValidated(true);
      };

      // send mail via php
      const sendmailHandler = (event,form) =>{         
          event.preventDefault();
          const elmContainer = document.querySelector('#form_errors'); 
          
          // php form processing request
          axios({
            method: "POST", 
            url:"mailer.php",
            data: JSON.stringify(formData)
          })
          .then( response =>{
              if(response.data.status === 'success'){
                elmContainer.classList = 'text-success';
                elmContainer.textContent = response.data.message;
                setValidated(false);
                form.reset();            
              }else{
                elmContainer.classList = 'text-danger';
                elmContainer.textContent = response.data.error.join(', ');
              }
          })
          .catch(error => {
              elmContainer.classList = 'text-danger';
              elmContainer.textContent = error;
          })
      }

      return (
          <React.Fragment>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Row>
                <h2 className="row-title text-light">Contact</h2>
              </Form.Row>
              <Form.Row>
                
                <Form.Group as={Col} xs={12} sm={6} controlId="validationCustom01">
                  <Form.Label className="sr-only">Full name</Form.Label>
                  <Form.Control required
                                name="full_name"
                                type="text"
                                placeholder="Full name"
                                defaultValue=""
                                onChange={event=>inputHandler(event)}
                              />
                </Form.Group>

                <Form.Group as={Col} xs={12} sm={6} controlId="validationCustom02">
                  <Form.Label className="sr-only">Your Email</Form.Label>
                  <Form.Control required
                                name="email"
                                type="email"
                                placeholder="Email"
                                defaultValue=""
                                onChange={event=>inputHandler(event)}
                              />
                </Form.Group>

                <Form.Group as={Col} xs={12} sm={6} controlId="validationCustom03">
                  <Form.Label className="sr-only">Phone Number</Form.Label>
                  <Form.Control required
                                pattern="[0-9]{10}"
                                name="phone"
                                type="tel"
                                placeholder="Phone"
                                defaultValue=""
                                onChange={event=>inputHandler(event)}
                              />
                </Form.Group>

                <Form.Group as={Col} xs={12} sm={6} controlId="validationCustom04">
                  <Form.Label className="sr-only">Order ID (Optional)</Form.Label>
                  <Form.Control name="order_id"
                                type="text"
                                placeholder="Order ID (Optional)"
                                defaultValue=""
                                onChange={event=>inputHandler(event)}
                              />
                </Form.Group>

                <Form.Group as={Col} xs={12} controlId="validationCustom05">
                  <Form.Label className="sr-only">Message</Form.Label>
                  <Form.Control required
                                name="message"
                                as="textarea"
                                rows={3}
                                type="textarea"
                                placeholder="Message"
                                defaultValue=""
                                onChange={event=>inputHandler(event)}
                              />
                </Form.Group>  
              </Form.Row>
              
              <Form.Row>
                <div id="form_errors"></div>
              </Form.Row>

              <Form.Row>
                <Button type="submit" className="btn-info mx-auto mt-3 ">Submit form</Button>
              </Form.Row>
            </Form>
          </React.Fragment>
      );
}

export default FormContact;